import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
} from "@mui/material";

import MessageAddCard from "../Forms/MessageAddCard";

export default function AddModal({messages, setMessages, refresh, setRefresh, setErr, open, setOpen, setErrOpen, setErrMessage, handleClickOpen, handleClose, initialVals}) {

  
    return (
      <div style={{width: 100, paddingTop: 10}}>
        <Button
        size="large" variant="contained" color="primary" onClick={handleClickOpen}>
          Add
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          >
          <DialogContent>
          <MessageAddCard messages={messages} setMessages={setMessages} setOpen={setOpen} setErrOpen={setErrOpen} setErrMessage={setErrMessage}  refresh={refresh} setRefresh={setRefresh} setErr={setErr} initialVals={initialVals}/>
          </DialogContent>
        </Dialog>
      </div>
    );
  }